import { ID } from '@datorama/akita';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

import { Entity, Column, OneToMany } from '../entity';
import { Result } from '../interfaces/helpers';
import { IEntity } from '../interfaces/models';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';
import { EventAssignmentService } from '../services/eventAssignment';
import { EventAssignment } from './eventAssignment.model';

export interface ISalesEvent extends IEntity {
  eventName: string;
  salesActivity: string;
  createdByUserDate: string;
  modifiedByUserDate: string;
  active: boolean;
  events?: Observable<Result<EventAssignment>>;
}

@Entity({
  name: PageTitles.sales,
  language: LanguagePage.sales,
})
export class SalesEvent implements ISalesEvent {
  @Column({
    type: ColumnType.string,
    isEditable: true,
    table: {
      defaultPosition: 1,
    },
    form: {
      defaultPosition: 1,
    },
  })
  eventName: string;

  @Column({
    type: ColumnType.option,
    isEditable: true,
    table: {
      defaultPosition: 2,
    },
    form: {
      defaultPosition: 2,
    },
  })
  salesActivity: string;

  @Column({
    type: ColumnType.boolean,
    isEditable: true,
    table: {
      defaultPosition: 3,
    },
    form: {
      defaultPosition: 3,
    },
  })
  active: boolean;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 4,
    },
  })
  createdByUserDate: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 5,
    },
  })
  modifiedByUserDate: string;

  @OneToMany({
    repository: EventAssignmentService,
    expression: { eventId: (i: SalesEvent) => i.id },
  })
  events: Observable<Result<EventAssignment>>;

  id: ID;
  createdBy: string;
  createdAt: Date;
  modifiedBy: string;
  modifiedAt: Date;

  constructor(
    sales: ISalesEvent = {
      id: '',
      eventName: '',
      salesActivity: '',
      createdBy: '',
      createdAt: new Date(),
      modifiedBy: '',
      modifiedAt: new Date(),
      active: true,
      createdByUserDate: '',
      modifiedByUserDate: '',
    }
  ) {
    const {
      id,
      eventName,
      salesActivity,
      createdBy,
      createdAt,
      modifiedBy,
      modifiedAt,
      active,
      modifiedByUserDate,
      createdByUserDate,
    } = sales;
    this.id = id;
    this.eventName = eventName;
    this.salesActivity = salesActivity;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
    this.modifiedBy = modifiedBy;
    this.modifiedAt = modifiedAt;
    this.active = active;
    this.configDates();
  }

  static createFromDTO(record: ISalesEvent): SalesEvent {
    return new SalesEvent({
      ...record,
      createdAt: new Date(record.createdAt),
      modifiedAt: new Date(record.modifiedAt),
    });
  }

  public configDates() {
    const datepipe: DatePipe = new DatePipe('en-CA');
    const createdAtDate = datepipe.transform(
      this.createdAt,
      'MMM dd, YYYY HH:mm:ss'
    );
    const modifiedAtDate = datepipe.transform(
      this.modifiedAt,
      'MMM dd, YYYY HH:mm:ss'
    );
    this.createdByUserDate = this.createdBy + ',' + createdAtDate.toString();
    this.modifiedByUserDate = this.modifiedBy + ',' + modifiedAtDate.toString();
  }
}
